import { useQuery } from "@tanstack/react-query";
import { Card, Table, Tag, Typography } from "antd";
import { http } from "../../shared/api/http";
import { useAppConfig } from "../../shared/config/AppConfigProvider";
import { formatDateTime } from "../../shared/utils/formatters";

type Activity={id:string;action:string;entityType:string;entityId:string;createdAt:string;actor:{displayName:string;email:string}|null}

export function ActivityLogsPage(){
  const {text}=useAppConfig();
  const query=useQuery({queryKey:["activity-logs"],queryFn:async()=>(await http.get<Activity[]>("/v1/activity-logs")).data});
  return <section><div className="page-title"><div><Typography.Title level={2}>{text.activity}</Typography.Title><Typography.Paragraph type="secondary">Immutable audit trail for important operations</Typography.Paragraph></div></div><Card><Table rowKey="id" loading={query.isLoading} dataSource={query.data??[]} scroll={{x:760}} columns={[
    {title:text.action,dataIndex:"action",key:"action",render:value=><Tag>{value}</Tag>},
    {title:text.entity,key:"entity",render:(_,row)=><><b>{row.entityType}</b><br/><Typography.Text type="secondary" className="mono">{row.entityId}</Typography.Text></>},
    {title:text.actor,key:"actor",render:(_,row)=>row.actor?.displayName??"System"},
    {title:text.time,dataIndex:"createdAt",key:"time",render:formatDateTime}
  ]}/></Card></section>;
}
